import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "db622hjtv1J0IBz67fV0xUQ", "EventManager", undefined);

import { log } from "cc";

var EventManager = /*#__PURE__*/function () {
  function EventManager() {
    _defineProperty(this, "_eventList", new Map());
  }

  var _proto = EventManager.prototype;

  _proto.onLoad = function onLoad() {
    EventManager._I = this;
  };

  _proto.addEventLintener = function addEventLintener(type, callback, target) {
    var eventInfo = this._eventList.get(type);

    var isHandle = false;

    if (eventInfo && eventInfo.length > 0) {
      for (var i = 0; i < eventInfo.length; ++i) {
        if (eventInfo[i].target == target) {
          eventInfo[i].callback = callback;
          isHandle = true;
          break;
        }
      }

      if (!isHandle) {
        eventInfo.push({
          target: target,
          callback: callback
        });
      }

      this._eventList.set(type, eventInfo);
    } else {
      this._eventList.set(type, [{
        callback: callback,
        target: target
      }]);
    }
  };

  _proto.removeEvent = function removeEvent(target) {
    var _this = this;

    this._eventList.forEach(function (eventInfo, k) {
      if (eventInfo.length > 0) {
        for (var i = 0; i < eventInfo.length; ++i) {
          if (!eventInfo[i]) {
            log("eventInfo[i] --------", eventInfo);
            continue;
          }

          if (eventInfo[i].target == target) {
            var index = eventInfo.indexOf(eventInfo[i]);
            eventInfo.splice(index, 1);

            _this._eventList.set(k, eventInfo);
          }
        }
      }
    });
  } //處理事件
  ;

  _proto.handleEvent = function handleEvent(type) {
    var eventInfo = this._eventList.get(type);

    if (eventInfo && eventInfo.length > 0) {
      for (var _len = arguments.length, restOfName = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        restOfName[_key - 1] = arguments[_key];
      }

      for (var i = 0; i < eventInfo.length; ++i) {
        var _eventInfo$i$callback;

        if (!eventInfo[i]) {
          continue;
        }

        (_eventInfo$i$callback = eventInfo[i].callback).call.apply(_eventInfo$i$callback, [eventInfo[i].target].concat(restOfName));
      }
    }
  };

  _createClass(EventManager, null, [{
    key: "I",
    get: function get() {
      if (!EventManager._I) {
        EventManager._I = new EventManager();
      }

      return EventManager._I;
    }
  }]);

  return EventManager;
}();

_defineProperty(EventManager, "_I", null);

export { EventManager as default };

_cclegacy._RF.pop();